<script setup>
import { ref, computed, watch } from 'vue'

const props = defineProps({
	relationship: {
		type: String, // the relationship name
		required: true,
	},
	roles: {
		type: Array, // an array of rolenames, subarrayed with permission names
		required: true,
	},
	errors: {
		type: Object,
		default: () => ({}),
	},
	currentRole: {
		type: String,
		
	},
})

const emit = defineEmits([
	'role-selected',
])

//capitalise the first letter of a string
function formatPermissionName(string) {
	let newString =  string.charAt(0).toUpperCase() + string.slice(1);
	return newString.replace(/_/g, ' ')
}
/**
 * roles are prefixed with the relationship name:
 * 	[
	   	'organisations:owner' => [
			'view',
			'update',
			'request_cancellation',
			'make_payments',
			'view_invoices',
			'manage_contacts',
		],
		'organisations:accounts' => [
			'view',
			'update',
			'make_payments',
			'view_invoices',
		],
		'organisations:contact' => [
			'view',
		],
 *	]
 */

const selectedRole = ref(props.currentRole?props.currentRole:'')

watch(selectedRole, (newRole) => {
	emit('role-selected', props.roles.find(role => role.name === newRole))
})

const selectOptions = computed(() => {
	return props.roles.map(role => {
		return {
			label: role.name.replace(props.relationship + ':', ''),
			value: role.name,
		}
	}).reduce((acc, cur) => {
		acc[cur.value] = cur.label
		return acc
	}, {})
})
</script>

<template>
	<div class="relationship-role-selector">
		<Input
			type="select" 
			v-model="selectedRole"
			:errors="errors"
			class="block w-full sm:text-sm"
			:options="selectOptions"
			testid="role-selector"
		/>

		<Alert v-if="selectedRole" type="warning" class="mt-2">
			<p class="mb-2">This role grants the following permissions:</p>
			<ul class="text-sm ml-4">
				<li class="  list-disc"
					v-for="permission in roles.find(role => role.name === selectedRole).permissions"
					:key="permission.id"
				>
					{{ formatPermissionName(permission.name) }}
				</li>
			</ul>
		</Alert>
	</div>
</template>